import React, {useState, useRef, useEffect} from 'react';
import "./ActionItemCommentAddForm.css";
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function ActionItemCommentAddForm() 
{
    const { app_user, action_item, setSelectedActionItem, setActionItemDisplayRefresh } = useCTAL();
    
    const [error, setError] = useState();
    const [form_changed_flag, setFormChangedFlag] = useState(false);
    const [create_comment_button_type, setCreateCommentButtonType] = useState("btn btn-sm btn-secondary mt-2");
    const initRef = useRef("");
    
    useEffect(() =>
    {
        if (DEBUG) console.log(`ActionItemCommentAddForm - form_changed_flag: ${form_changed_flag}`);
        if (!form_changed_flag)
            setCreateCommentButtonType("btn btn-sm btn-secondary mt-2");
        else
            setCreateCommentButtonType("btn btn-sm btn-primary mt-2");
    }, [form_changed_flag]);

    var action_item_id = action_item.ActionItemID
    
    const reset_action_item = () => { 
        setSelectedActionItem(action_item); //Keep this Action Item Detail Displayed
        setActionItemDisplayRefresh(true);  //Trigger the Action-Item bulk download in ActionItem.mjs
    }

    const send_add_comment = (body) => { 
        console.log(`ActionItemCommentAddForm - Send Add Comment body: ${body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-set`, { method: "POST", body: body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: body })
            .then(() => reset_action_item())
            .catch(setError);
    }

    const add_comment = () => { 
        if ((!action_item) || (!app_user)) return;
        if (!form_changed_flag) return;

        if (document.getElementById("add-comment-text").value == "") return;

        var type = "create_comment";
        var comment_type = "Action-Item";
        var target_pk = action_item.PK;
        var target_sk = action_item.SK;
        var user_full_name = app_user.UserFullName;
        var comment = document.getElementById("add-comment-text").value;

        var body = JSON.stringify({type, comment_type, target_pk, target_sk, user_full_name, comment});
       
        send_add_comment(body);

        document.getElementById("add-comment-text").value = "";

        setFormChangedFlag(false);
    }
    
    const form_changed = () => { 
        setFormChangedFlag(true);
    }

    return ( 
        <>
            <div id="floatingTextarea2" class="form-floating mt-2">
                <textarea id="add-comment-text" class="form-control" placeholder="Add a comment here" onChange={form_changed}></textarea>
                <label htmlFor="floatingTextarea2">Add a Comment</label>
            </div>
            
            <div class="row">
                <div class="col text-end">                      
                    <a href="#" id="add-comment-btn" class={create_comment_button_type} onClick={ () => add_comment() }>Add Comment</a>
                </div>
            </div>
        </>
    );
}

/*
 

 style="height: 100px"

             <div id="ref-container" class="container-fluid">
                <div id="ref-row" class="row row-cols-12">
                    <div class="col">1</div>
                    <div class="col">2</div>
                    <div class="col">3</div>
                    <div class="col">4</div>
                    <div class="col">5</div>
                    <div class="col">6</div>
                    <div class="col">7</div>
                    <div class="col">8</div>
                    <div class="col">9</div>
                    <div class="col">10</div>
                    <div class="col">11</div>
                    <div class="col">12</div>
                </div>
            </div>


*/